<script setup>
import {computed} from 'vue'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const contentAreaName = computed(() => pageEditorStore.activeContentAreaName)
const isHeaderOrFooterArea = computed(() => contentAreaName.value === 'Page header'
    || contentAreaName.value === 'Page footer')

const setOffcanvas = () => {
    pageEditorStore.offcanvasEnd = true
}
</script>

<template>
    <section class="d-flex flex-column h-100 p-3">
        <h2 class="h5 mb-3">
            {{ contentAreaName }}
            <br>
            <small class="lh-1 text-body-secondary">area</small>
        </h2>

        <div v-if="!isHeaderOrFooterArea" class="d-grid gap-1">
            <Button @click="setOffcanvas" class="btn-sm border d-flex align-items-center gap-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#addContentOffcanvas"
                    aria-controls="addContentOffcanvas">
                <i class="bi bi-plus-lg"></i>
                New content
            </Button>

            <Button @click="setOffcanvas" class="btn-sm border d-flex align-items-center gap-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#addExistingContentOffcanvas"
                    aria-controls="addExistingContentOffcanvas">
                <i class="bi-diagram-3-fill"/>
                Existing content
            </Button>
        </div>
    </section>
</template>